import * as React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import WarningIcon from "@mui/icons-material/Warning";
import { useNavigate } from "react-router-dom";

const PermissionPage = () => {
  const navigate = useNavigate();

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <WarningIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
      <Typography variant="h2" sx={{ mb: 2 }}>
        Permission Denied
      </Typography>
      <Typography variant="body1">
        You do not have the necessary permissions to view this page.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 2 }}
        onClick={() => navigate(-1)}
      >
        Go Back
      </Button>
    </Container>
  );
};

export default PermissionPage;
